import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { CancellationStatus } from './cancellation.constants';

export const { Types: CancellationTypes, Creators: CancellationActions } = createActions(
  {
    setData: ['bookingId', 'token', 'experienceName'],
    requestCancel: [],
    setStatus: ['status'],
  },
  { prefix: 'CANCELLATION_' }
);

export const INITIAL_STATE = Immutable({
  bookingId: null,
  experienceName: null,
  token: null,
  status: CancellationStatus.INITIAL,
});

const handleSetStatus = (state, { status }) => state.set('status', status);

const handeSetData = (state, { bookingId, token, experienceName }) =>
  state.merge({
    bookingId,
    token,
    experienceName,
  });

export const reducer = createReducer(INITIAL_STATE, {
  [CancellationTypes.SET_STATUS]: handleSetStatus,
  [CancellationTypes.SET_DATA]: handeSetData,
});
